export function initTimePicker($elems) {
  $elems.each((index, elem) => $(elem).datetimepicker({
    format: 'HH:mm',
    icons: {
      time: 'fa fa-clock-o',
      date: 'fa fa-calendar',
      up: 'fa fa-chevron-up',
      down: 'fa fa-chevron-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      today: 'fa fa-star',
      clear: 'fa fa-trash-o',
      close: 'fa fa-remove',
    },
    stepping: $(elem).data('stepping') || 1,
    locale: (I18n.locale === 'en') ? 'en-gb' : I18n.locale,
  }));
}

export function initDatePicker($elems) {
  $elems
    .each((index, elem) => $(elem).datetimepicker({
      format: 'DD.MM.YYYY',
      showTodayButton: true,
      showClear: true,
      minDate: $(elem).data('no-min-date') ? false : moment().subtract(10, 'y'),
      maxDate: moment().add(10, 'y'),
      widgetPositioning: {
        horizontal: $(elem).data('position-horizontal') || 'auto',
      },
      icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-star',
        clear: 'fa fa-trash-o',
        close: 'fa fa-remove',
      },
      locale: (I18n.locale === 'en') ? 'en-gb' : I18n.locale,
    }));
}

export function initDateTimePicker($elems) {
  $elems
    .datetimepicker({
      // debug: true,
      format: 'DD.MM.YYYY - HH:mm',
      showTodayButton: true,
      showClear: true,
      minDate: moment().subtract(10, 'y'),
      maxDate: moment().add(10, 'y'),
      icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-star',
        clear: 'fa fa-trash-o',
        close: 'fa fa-remove',
      },
      locale: (I18n.locale === 'en') ? 'en-gb' : I18n.locale,
    });
}

export default function initDateTimePickers() {
  initDateTimePicker($('.datetimepicker-field'));
  initDatePicker($('.datepicker-field'));
  initTimePicker($('.timepicker-field'));
}

$(document).on('ready turbolinks:load', () => {
  initDateTimePickers();
});
